<template>
  <div class="many-aspect">
    <div class="many-aspect-title">
      <div>项目专栏</div>
    </div>
    <div class="many-aspect-content">
      <!-- <ul class="tabs">
        <li class="li-tab" v-for="(item,index) in tabsParam"
        @click="toggleTabs(index)"
        :class="{ active: index === nowIndex }" :key="index">
        {{item}}
        </li>
      </ul> -->
      <div class="content" v-show="nowIndex === 0">
        <div class="flex-image" v-for="(item, index) in itemData" :key="index">
          <div class="divImg" @click="goDetails(item)">
            <div class="icon-title" v-if="item.trade">
              <span>{{item.trade.name}}</span>
            </div>
            <p>{{item.name}}</p>
            <img src="@/assets/cover.jpg" v-if="!item.logoImage"/>
            <img v-lazy="{ src: item.logoImage.url, loading: require('@/assets/coverpic.jpg') }" v-else/>
            <span class="text" v-if="item.name !== '敬请期待'">{{copyWrite[index].content}}</span>
          </div>
        </div>
        <div class="flex-image" style="background: #f9faff" v-if="itemData.length % 3 != 0"></div>
      </div>
      <!-- <div class="content" v-show="nowIndex === 1">
        <div class="flex-image text" v-for="(item, index) in imgList" :key="index">
          <div class="divImg" @click="getPoint(item)">
            <p v-if="item.textWord">{{item.textWord}}</p>
            <img :src="item.url" />
            <span class="textNowIndex" v-show="index !== 5">{{item.textWord}}</span>
            <span v-show="index !== 5">{{item.textWord}}</span>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import { Contents } from "../../../../../gqlapi/Contents.js";

export default {
  name: "manyAspect",
  data () {
    return {
      tabsParam: [ "上线项目", "即将上线" ],
      nowIndex: 0,
      itemData: [],
      imgList: [
        {
          textWord: "数据服务",url: require("../pythonImg/comeSoon/shuju1.png")
        },
        {
          textWord: "企业服务",url: require("../pythonImg/comeSoon/qiye2.png")
        },
        {
          textWord: "人力资源",url: require("../pythonImg/comeSoon/renli3.png")
        },
        {
          textWord: "基础服务", url: require("../pythonImg/comeSoon/jichu4.png")
        },
        {
          textWord: "系统管理服务",url: require("../pythonImg/comeSoon/xitong5.png")
        },
        {
          textWord: "敬请期待", url: require("../pythonImg/mund.png")
        }
      ],
      copyWrite: [
        // { title: "十次方", content: "十次方是一个IT技术交流社区，致力于为中国软件开发者提供知识传播、在线学习、职业发展等全生命周期服务。" },
        { title: "美多商城", content: "美多商城属于B2C电商，商城自身销售商品给顾客。系统包括前台商城及运营管理后台。" },
        { title: "黑马头条", content: "黑马头条是一款个性化科技资讯推荐类阅读产品，本项目主要着手于获取热门新闻资讯，通过大数据分析用户喜好推送资讯新闻。" },
        { title: "天天生鲜", content: "天天生鲜是一个围绕着老百姓餐桌的生鲜B2C电商平台。为每一位用户带来放心的食材、实惠的价格和品质的服务。" },
        { title: "新经咨询", content: "新经资讯网是一个新闻资讯类门户网站，为用户提供新闻资讯内容。" },
        { title: "黑马监控与链路追踪项目", content: "随着部署架构的不断演进，查找并解决系统问题的难度也在增强。这就需要引入链路追踪与监控，构建可观测的服务系统。" },
        { title: "自动化运维中台", content: "自动化运维中台是一套基于DevOps理念的运维造化管理系统。它整合了CMDB、CI/CD、监控、自动化工具、项目管理、版本管理等常用运维系统。" },
      ]
    }
  },
  created () {
    this.getList("3")
  },
  methods: {
    toggleTabs (index) {
      if (index === 0) {
        this.$trackEvent("上线项目", '点击文字', "上线项目")
      } else {
        this.$trackEvent("即将上线", '点击文字', "即将上线")
      }
      this.nowIndex = index
    },
    goDetails (value) {
      if (value.name !== "敬请期待") {
        window.sessionStorage.setItem("detailsId", String(value.id))
        this.$trackEvent(value.name, '点击图标', value.name)
        let routerData
        if (value.router) {
          routerData = this.$router.resolve({
            path: value.router,
          });
        } else if (value.p_template && value.p_template.code) {
          routerData = this.$router.resolve({
            path: "/" + value.p_template.code
          })
        } else {
          routerData = this.$router.resolve({
            path: "/details"
          })
        }
        window.open(routerData.href, "_blank")
      }
    },
    getPoint (list) {
      this.$trackEvent(list.textWord, '点击图标', list.textWord)
    },
    getList (ids) {
      // this.$apollo.query({
      //     query: Contents,
      //     variables: {
      //       subjectID: ids,
      //       isPublish: true,
      //       name: ''
      //     }
      //   })
        this.$axios.post('/api',{
            operationName: "Contents",
            variables:{
                subjectID: ids,
                isPublish: true,
                name: ''
            },
            query: Contents
        }).then((res) => {
            if (!res.data.data.pContents.some(n => n.name == '敬请期待')){
                this.itemData = res.data.data.pContents.length % 3 == 0 ? res.data.data.pContents : this.formatItemData(res.data.data.pContents)
            } else {
                this.itemData = res.data.data.pContents
            }
        })
        .catch(() => {
        })
    },
    formatItemData (item = []) {
      console.log(232323, item)
      const obj = {
            id: new Date(),
            name: "敬请期待",
            logoImage: {
              url: require("../pythonImg/mund.png")
            }
          }
      item.push(obj)
      // console.log(3333,item)
      // if (item.length >= 6) {
      //   item = item.slice(0, 5)
      // } else {
      //   while(item.length < 6) {
      //     const obj = {
      //       id: new Date(),
      //       name: "敬请期待",
      //       logoImage: {
      //         url: require("../pythonImg/mund.png")
      //       }
      //     }
      //     item.push(obj)
      //   }
      // }
      return item
    }
  }
}
</script>

<style lang="scss" socped>
  .many-aspect {
    width: 100%;
    // height: 760px;
    // background: #1a1f34;
    background: #f9faff;
    min-width: 1200px;
    .many-aspect-title {
      max-width: 1200px;
      width: 100%;
      margin: 0 auto;
      div {
        padding-top: 75px;
        width: 100%;
        font-size: 32px;
        // font-family: "Fontquan-qingkehuangyouti";
        font-family:  "PingFangSC", "PingFangSC-Regular";
        text-align: center;
        font-weight: 600;
        color: #19232B;
        line-height: 47px;
      }
    }
    .many-aspect-content {
      max-width: 1200px;
      margin: 40px auto 0;
      padding-bottom: 60px;
      .active {
        padding-bottom: 18px;
        border-bottom: 4px solid #1a51ff;
        font-size: 22px;
        font-family:  "PingFangSC", "PingFangSC-Regular";
        color: #ffffff;
       }
      ul {
        width: 100%;
        font: 0;
        padding: 0;
        display: flex;
        text-align: center;
        border-bottom: 1px solid #313648;;
        li {
          margin-top: 10px;
          margin: 0 240px;
          cursor: pointer;
          width: 50%;
          height: 100%;
          display:inline-block;
          text-align: center;
          font-size: 22px;
          font-family:  "PingFangSC", "PingFangSC-Semibold";
        }
      }
      .content {
        width: 1200px;
        box-sizing: border-box;
        padding-top: 20px;
        // height: 458px;
        height: auto;
        overflow: hidden;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        .flex-image {
          // flex: 1;
          width: 385px;
          margin-bottom:20px;
          height: 188px;
          position: relative;
          .divImg {
            // position: relative;
            overflow: hidden;
            text-align: center;
            cursor: pointer;
            width: 100%;
            height: 100%;
            position: relative;
            .icon-title {
              position: absolute;
              top: 10px;
              left: 20px;
              width: 90px;
              height: 30px;
              background-color: rgba(0, 0, 0, 0.3);
              border-radius: 8px;
              span {
                display: block;
                line-height: 30px;
                color: #fff;
                font-weight: 400;
                opacity: .8;
              }
            }
            p {
              position: absolute;
              font-size: 30px;
              font-weight: 500;
              width: 100%;
              top: 40%;
              text-align: center;
              color: #fff;
              font-family:  "PingFangSC", "PingFangSC-Semibold";
            }
            img {
              width: 400px;
              height: 188px;
              vertical-align: bottom;
              // display: block;
              // height: 229px;
            }
            .text {
              opacity: 0;
              line-height: 20px;
              padding: 0 8px 10px 16px;
              box-sizing: border-box;
              display: block;
              position: absolute;
              width: 100%;
              bottom: 0;
              height: auto;
              // padding: 8px 0;
              background-color: rgba(0, 0, 0, 0.1);
              transition: all 0.25s;
              transform: translateY(100%);
              color: #fff;
              font-size: 14px;
              text-align: left;
              font-family:  "PingFangSC", "PingFangSC-Semibold";
            }
            .textNowIndex {
              display: block;
              position: absolute;
              width: 100%;
              left: 0;
              right: 0;
              bottom: 0;
              height: auto;
              padding: 14px 0;
              background-color: rgba(0, 0, 0, 0.1);
              transition: all 0.25s;
              transform: translateY(100%);
              color: #fff;
              font-size: 18px;
              font-family:  "PingFangSC", "PingFangSC-Semibold";
            }
          }
        }
        .flex-image:hover .text {
          transform: translateY(0%);
          transition: all 0.3s;
          opacity: 1;
        }
        .flex-image:hover .textNowIndex {
          transform: translateY(0%);
          opacity: 1;
          transition: all 0.3s;
        }
        .none-data {
          width: 1200px;
          height: auto;
          font-size: 20px;
          text-align: center;
          font-family:  "PingFangSC", "PingFangSC-Semibold";
        }
      }
    }
  }
</style>